import React from 'react';
import { Helmet } from 'react-helmet';
interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
}
export const SEO: React.FC<SEOProps> = ({
  title = 'Zakelijke website laten maken financieel adviseur | Noord Digital',
  description = 'Zakelijke website laten maken financieel adviseur? Noord Digital bouwt professionele WordPress websites voor de hele financiële dienstverlening. Van slimme instapoplossingen tot compleet maatwerk webdesign.',
  keywords = 'zakelijke website laten maken financieel adviseur, offerte website administratiekantoor, kosten professionele website accountantskantoor, webdesign financieel adviseur, WordPress website financiële dienstverlening, professionele website adviesbureau, zakelijke website maken, website laten bouwen accountant, administratiekantoor website, hypotheekadviseur website',
  canonical = 'https://noorddigital.nl',
  ogImage = 'https://noorddigital.nl/og-image.jpg'
}) => {
  return <Helmet data-id="element-583">
      {/* Primary Meta Tags */}
      <title data-id="element-584">{title}</title>
      <meta name="title" content={title} data-id="element-585" />
      <meta name="description" content={description} data-id="element-586" />
      <meta name="keywords" content={keywords} data-id="element-587" />
      <link rel="canonical" href={canonical} data-id="element-588" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" data-id="element-589" />
      <meta property="og:url" content={canonical} data-id="element-590" />
      <meta property="og:title" content={title} data-id="element-591" />
      <meta property="og:description" content={description} data-id="element-592" />
      <meta property="og:image" content={ogImage} data-id="element-593" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-id="element-594" />
      <meta property="twitter:url" content={canonical} data-id="element-595" />
      <meta property="twitter:title" content={title} data-id="element-596" />
      <meta property="twitter:description" content={description} data-id="element-597" />
      <meta property="twitter:image" content={ogImage} data-id="element-598" />

      {/* Language */}
      <html lang="nl" data-id="element-599" />
    </Helmet>;
};